export const BASE_MEDIA_URL =
  process.env.REACT_APP_UPLOAD_URL ?? 'https://dev-api.01maktab.uz';
